import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

const supportedActions = [
  'VALIDATE_PATIENT_INFO',
  'SAVE_PATIENT_INFO_ERROR',
  'SAVE_COMMON_ERRORS',
  'SAVE_PATIENT_INFO',
  'CLEAR_ERRORS',
  'CLEAR',
];

export const consts = createConsts('dashboard', 'record', ...supportedActions);
export const actions = createActions(consts);

const initialState = {
  patient: {},
  patientValidationError: null,
  commonErrors: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.SAVE_PATIENT_INFO_ERROR:
      return {
        ...state,
        patientValidationError: payload,
      };
    case consts.SAVE_COMMON_ERRORS:
      return {
        ...state,
        commonErrors: payload,
      };
    case consts.SAVE_PATIENT_INFO:
      return {
        ...state,
        patient: payload,
        patientValidationError: null,
      };
    case consts.CLEAR_ERRORS:
      return {
        ...state,
        commonErrors: null,
        patientValidationError: null,
      };
    case consts.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/dashboard/record.js